import { gql } from '../../../__generated__';

export const SHARE_FEEDBACK =
  gql(`mutation AddFloorPlanFeedbackWeb($data: AddFloorPlanFeedbackWebInput) {
  addFloorPlanFeedbackWeb(data: $data) {
    status
  }
}`);

export const DELETE_FLOOR_PLAN = gql(`
  mutation DeleteFloorPlan($floorPlanId: ID!) {
    deleteFloorPlan(floorPlanId: $floorPlanId) {
      status
    }
  }
`);
